var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exportBox"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("导出数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }